import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface LandscapingDescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const LandscapingDescription: React.FC<LandscapingDescriptionProps> = ({
    required,
    readOnly,
    propertyGuid,
    isReview = false,
}) => {
    const [landscaping, set_landscaping] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Final Structure']?.['Landscaping']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Final Structure': { ...b.values?.['Final Structure'], 'Landscaping': [v, b.values?.['Final Structure']?.['Landscaping']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={landscaping}
                />
            ) : (
                <TextBox
                    value={landscaping}
                    onChange={(value) => set_landscaping(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
